import HelpIcon from '@material-ui/icons/Help';

function Help() {
  return <HelpIcon />;
}

export default Help;
